/*
 * @Author: elevencong elevencong@tencent.com
 * @Date: 2023-09-07 19:54:34
 * @LastEditors: elevencong elevencong@tencent.com
 * @LastEditTime: 2023-09-07 23:06:05
 * @FilePath: /milo-core/src/common/postMessageUtil.js
 * @Description: postMessage iframe跨域通信相关方法封装
 */
// 判断postMessage是否合法来源
import { g, isFunction } from "./base";

var isLegalOrigin = function isLegalOrigin(url) {
  // 检测是否合法域名
  // 合法域名列表
  var whiteDomain = ['qq.com']; // 白名单

  var blackDomain = ['p.imtt.qq.com']; // 黑名单

  var isLegal = false;
  var regStr = '^(https\\:\\/\\/|http\\:\\/\\/|\\/\\/|)([0-9a-z-A-Z]+\\.)*reg(\\:[0-9]*){0,1}(\\/{1,2}.*){0,1}$';
  var regWhite = null; // 判断白名单

  for (var i = 0; i < whiteDomain.length; i++) {
    regWhite = new RegExp(regStr.replace('reg', whiteDomain[i].replace(/\./g, '\\.')));

    if (regWhite.test(url)) {
      isLegal = true;
    }
  }

  if (isLegal == false) {
    // 不在白名单
    return false;
  } // 判断黑名单


  var regBlack = null;

  for (var _i = 0; _i < blackDomain.length; _i++) {
    regBlack = new RegExp(regStr.replace('reg', blackDomain[_i].replace(/\./g, '\\.')));

    if (regBlack.test(url)) {
      isLegal = false;
    }
  }

  return isLegal;
};

var postMessageProxy = {
  /**
   * 
   * @param {string} iframeName iframe name
   * @param {string} action action name
   * @param {string} callbackName callback name
   * @param {object} data 
   */
  postMessage: function postMessage(iframeName, action, callbackName) {
    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var postMessageData = {
      action: action,
      callbackName: callbackName,
      data: data
    };
    var iframe = g(iframeName);
    iframe.contentWindow.postMessage(JSON.stringify(postMessageData), "*");
  },
  addEventListener: function addEventListener(actionName) {
    if ('function' === typeof window.postMessage) {
      window.addEventListener('message', function (e) {
        if (!isLegalOrigin(e.origin)) {
          // 来源非法
          return;
        }

        var eData = {};

        if (!e.data) {
          // 没有数据
          return;
        } // 增加不是合法json的try catch


        try {
          if ('string' === typeof e.data) {
            eData = JSON.parse(e.data);
          } else {
            eData = e.data;
          }

          if (eData && eData.callbackName && eData.action == actionName) {
            var data = eData.data || '';
            isFunction(window[eData.callbackName]) && window[eData.callbackName](data);
          }
        } catch (e) {
          console.log('===postMessage err===', e);
        }
      }, false);
    }
  }
};
export default postMessageProxy;